import { useTalentInfo } from "@/api/services/main/talent";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TalentForm } from "@/features/talent/components/talent-form/TalentForm";
import { convertResToFormData } from "@/features/talent/utils/convertTalentFormData";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

export const TalentEditPage = () => {
  const queryResult = useTalentInfo();
  const { data, isLoading, refetch: refectTalentInfo } = queryResult;
  useValidateId("talentId", AppRoutes.talentList, queryResult);

  if (!data || isLoading) return <LoadingPage />;
  return <TalentForm defaultValues={convertResToFormData(data.data)} refectTalentInfo={refectTalentInfo} />;
};
